import React, { useEffect, useRef, useState } from 'react'
import { SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper';
import SuggestedProductCard from './SuggestedProductCardMobile.MiniCart';
import useBreakpoint from '../../../Hooks/useBreakpoint';
import SuggestedProductCardDesktop from './SuggestedProductCardDesktop.MiniCart';
import SuggestedProductSliderTitle from '../Utils/SuggestedProductSliderTitle';
import { StyledSuggestedProductSwiperMiniCart } from '../Styles/SuggestedProductSlider.Styling';
import { useCookies } from 'react-cookie';

const SWIPER_INDEX_COOKIE_KEY = 'swiperIndex_minicart';

const SuggestedProductsSlider = ({ suggestedProducts, sliderIntervalInSec }) => {

    const breakpoint = useBreakpoint();

    const swiperRef = useRef<any>(null);
    const [cookies, setCookie] = useCookies([SWIPER_INDEX_COOKIE_KEY]);
    const initialIndex = parseInt(cookies[SWIPER_INDEX_COOKIE_KEY] || '0', 10);
    const [activeIndex, setActiveIndex] = useState<number>(initialIndex);

    const handleSlideChange = () => {
        if (swiperRef.current) {
            const newIndex = swiperRef.current.activeIndex;
            setActiveIndex(newIndex);

            setCookie(SWIPER_INDEX_COOKIE_KEY, newIndex, { path: '/' });
        }
    };

    useEffect(() => {
        if (swiperRef.current && swiperRef.current.initialized) {
            swiperRef.current.slideTo(activeIndex, 0);
        }
    }, [suggestedProducts]);


    return (
        <div className='w-full'>
            <SuggestedProductSliderTitle className='font-satoshi-bold mb-[16px] ml-[16px] mt-[26px]' />
            <StyledSuggestedProductSwiperMiniCart
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                onSlideChange={handleSlideChange}
                initialSlide={activeIndex}

                pagination={false}
                navigation={true}
                modules={[Navigation, Autoplay]}
                lazy={true}
                autoplay={sliderIntervalInSec ? { delay: sliderIntervalInSec * 1000 } : false}
            >
                {suggestedProducts.map((product) => (
                    <SwiperSlide key={product.id}>
                        {breakpoint === "sm" ?
                            <SuggestedProductCard product={product} className='h-full' />
                            :
                            <SuggestedProductCardDesktop product={product} className='h-full' />
                        }
                    </SwiperSlide>
                ))}
            </StyledSuggestedProductSwiperMiniCart>
        </div>
    )
}

export default SuggestedProductsSlider